<app-career-header-banner></app-career-header-banner>
<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
  <span class="font-bold text-3xl website-heading">Diverse culture where curious minds collaborate</span>
</div>

<div class="w-full flex flex-col items-center justify-center gap-8 mt-10">
  <!-- Job Details -->
  <div class="flex items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <div class="flex flex-col items-start justify-start gap-4 mt-4">
      <h3 class="text-xl font-bold">Product Manager</h3>
      <div class="flex gap-3 items-center">
        <img src="../../../../assets/images/careers/experience.png" alt="Experience Icon" class="size-5">
        <p class="text-black text-sm">5-7 years</p>
      </div>
      <div class="flex gap-3 items-center">
        <img src="../../../../assets/images/careers/job-location.png" alt="Location Icon" class="size-5">
        <p class="text-black text-sm">Pune, Maharashtra</p>
      </div>
      <div class="flex gap-3 items-center">
        <img src="../../../../assets/images/careers/employment-type.png" alt="Employment Type Icon" class="size-5">
        <p class="text-black text-sm">Full Time</p>
      </div>
    </div>
  </div>

  <!-- About the Role -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">About the Role</span>
    <p class="text-sm">
      The Product Manager is responsible for product planning, delivery, and marketing throughout the product 
      lifecycle. They will develop a vision and roadmap for the product based on input from internal stakeholders, 
      customers, market research, and their own industry insight. They will work closely with Product Head/Development/Engineering 
      and other teams to deliver products that align with this vision, meet market needs, and are delivered to a 
      consistently high-quality standard.
    </p>
  </div>

  <!-- Roles and Responsibilities -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Roles and Responsibilities</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let role of roles">
        {{role}}
      </li>
    </ul>
  </div>

  <!-- Qualification -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Qualification</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm">
        2-3 years of organic experience in product management is a must.
      </li>
      <li class="mb-2 text-sm">
        Bachelor’s or equivalent degree in Engineering or a related field.
      </li>
      <li class="mb-2 text-sm">
        Product management certifications would be an added advantage.
      </li>
    </ul>
  </div>

  <!-- Skills Required -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Skills Required</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let skill of skills">
        {{skill}}
      </li>
    </ul>
  </div>

  <!-- About Varroc Connect -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">About Varroc Connect</span>
    <p class="text-sm">
      In 2019, Varroc Engineering, a global Tier 1 Automotive player with ~1B$ revenues, acquired CarIQ with a vision 
      to deliver the next generation platform to the industry with a complete stack of software, hardware, and firmware. 
      Its customer base in global OEMs and the automotive industry fits this into their core business as the auto industry 
      evolves into a digital, electric, and connected future. Varroc Connect operates as a subsidiary of Varroc, run with 
      an independent CEO and leadership team, aiming to make it a global platform powerhouse in the industry leveraging 
      its strengths.
    </p>
  </div>

  <!-- Career Form Submission -->
  <app-career-form-submission class="px-5 w-5/6 md:w-3/4" [jobDescription]="selectedJob"></app-career-form-submission>
</div>